import { produce } from "immer";
import {
  FETCH_RESIDENCE,
  FETCH_RESIDENCE_SUCCESS,
  FETCH_RESIDENCE_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_RESIDENCE,
  ADD_RESIDENCE_SUCCESS,
  ADD_RESIDENCE_FAILURE,
  //
  EDIT_RESIDENCE,
  EDIT_RESIDENCE_SUCCESS,
  EDIT_RESIDENCE_FAILURE,
  //
  DELETE_RESIDENCE,
  DELETE_RESIDENCE_SUCCESS,
  DELETE_RESIDENCE_FAILURE,
  //
  DELETE_RESIDENCE_NOTE,
  DELETE_RESIDENCE_NOTE_FAILURE,
  DELETE_RESIDENCE_NOTE_SUCCESS,
  //
  DELETE_RESIDENCE_REMINDER_NOTE,
  DELETE_RESIDENCE_REMINDER_NOTE_FAILURE,
  DELETE_RESIDENCE_REMINDER_NOTE_SUCCESS,
  //
  OPEN_NOTE_ADD_MODAL,
  CLOSE_NOTE_ADD_MODAL,
  //
  OPEN_REMINDER_ADD_MODAL,
  CLOSE_REMINDER_ADD_MODAL,
  //
  OPEN_FAMILY_ADD_MODAL,
  CLOSE_FAMILY_ADD_MODAL,
  //
  ADD_RESIDENCE_NOTE,
  ADD_RESIDENCE_NOTE_SUCCESS,
  ADD_RESIDENCE_NOTE_FAILURE,
  //
  FETCH_RESIDENCE_NOTES,
  FETCH_RESIDENCE_NOTES_FAILURE,
  FETCH_RESIDENCE_NOTES_SUCCESS,
  //
  ADD_RESIDENCE_REMINDER,
  ADD_RESIDENCE_REMINDER_SUCCESS,
  ADD_RESIDENCE_REMINDER_FAILURE,
  //
  FETCH_RESIDENCE_REMINDERS,
  FETCH_RESIDENCE_REMINDERS_FAILURE,
  FETCH_RESIDENCE_REMINDERS_SUCCESS,
  //
  ADD_RESIDENCE_FAMILY_MEMBER,
  ADD_RESIDENCE_FAMILY_MEMBER_SUCCESS,
  ADD_RESIDENCE_FAMILY_MEMBER_FAILURE,
  //
  EDIT_RESIDENCE_FAMILY_MEMBER,
  EDIT_RESIDENCE_FAMILY_MEMBER_SUCCESS,
  EDIT_RESIDENCE_FAMILY_MEMBER_FAILURE,
  //
  FETCH_RESIDENCE_FAMILY_MEMBERS,
  FETCH_RESIDENCE_FAMILY_MEMBERS_FAILURE,
  FETCH_RESIDENCE_FAMILY_MEMBERS_SUCCESS,
  //
  GET_FAMILY_VIEW_DATA,
  GET_FAMILY_VIEW_DATA_FAILURE,
  GET_FAMILY_VIEW_DATA_SUCCESS,
} from "./constants";

export const initialState = {
  isFetchingResidence: false,
  isFetchingResidenceNotes: false,
  isFetchingResidenceReminders: false,
  residence: [],
  residenceNotes: [],
  residenceReminders: [],
  residenceFamilyMembers: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentResidence: {},
  currentResidenceNote: {},
  currentResidenceReminder: {},
  currentResidenceFamily: {},
  // Delete
  isDeleting: false,
  isNoteAddModalOpen: false,
  isReminderAddModalOpen: false,
  isFamilyAddModalOpen: false,
  isFetchingResidenceFamilyMembers: false,
};

const ResidenceReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_RESIDENCE:
        draft.isFetchingResidence = true;
        draft.currentResidence = {};
        break;
      case FETCH_RESIDENCE_SUCCESS:
        draft.isFetchingResidence = false;
        draft.residence = action.payload;
        break;
      case FETCH_RESIDENCE_FAILURE:
        draft.isFetchingResidence = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentResidence = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentResidence = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_RESIDENCE:
        draft.isSubmitting = true;
        break;
      case ADD_RESIDENCE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_RESIDENCE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_RESIDENCE:
        draft.isSubmitting = true;
        break;
      case EDIT_RESIDENCE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_RESIDENCE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_RESIDENCE:
        draft.isDeleting = true;
        break;
      case DELETE_RESIDENCE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_RESIDENCE_FAILURE:
        draft.isDeleting = false;
        break;
      // Delete Note
      case DELETE_RESIDENCE_NOTE:
        draft.isDeleting = true;
        break;
      case DELETE_RESIDENCE_NOTE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_RESIDENCE_NOTE_FAILURE:
        draft.isDeleting = false;
        break;
      // Delete Reminder Note
      case DELETE_RESIDENCE_REMINDER_NOTE:
        draft.isDeleting = true;
        break;
      case DELETE_RESIDENCE_REMINDER_NOTE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_RESIDENCE_REMINDER_NOTE_FAILURE:
        draft.isDeleting = false;
        break;
      // NOTE OPEN
      case OPEN_NOTE_ADD_MODAL:
        draft.isNoteAddModalOpen = true;
        break;
      case CLOSE_NOTE_ADD_MODAL:
        draft.isNoteAddModalOpen = false;
        break;
      // REMINDER OPEN
      case OPEN_REMINDER_ADD_MODAL:
        draft.isReminderAddModalOpen = true;
        break;
      case CLOSE_REMINDER_ADD_MODAL:
        draft.isReminderAddModalOpen = false;
        break;
      // FAMILY MODAL OPEN
      case OPEN_FAMILY_ADD_MODAL:
        draft.isFamilyAddModalOpen = true;
        break;
      case CLOSE_FAMILY_ADD_MODAL:
        draft.isFamilyAddModalOpen = false;
        break;
      case ADD_RESIDENCE_NOTE:
        draft.isSubmitting = true;
        break;
      case ADD_RESIDENCE_NOTE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_RESIDENCE_NOTE_FAILURE:
        draft.isSubmitting = false;
        break;
      // List
      case FETCH_RESIDENCE_NOTES:
        draft.isFetchingResidenceNotes = true;
        draft.currentResidenceNote = {};
        break;
      case FETCH_RESIDENCE_NOTES_SUCCESS:
        draft.isFetchingResidenceNotes = false;
        draft.residenceNotes = action.payload;
        break;
      case FETCH_RESIDENCE_NOTES_FAILURE:
        draft.isFetchingResidenceNotes = false;
        break;
      case ADD_RESIDENCE_REMINDER:
        draft.isSubmitting = true;
        break;
      case ADD_RESIDENCE_REMINDER_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_RESIDENCE_REMINDER_FAILURE:
        draft.isSubmitting = false;
        break;
      // List
      case FETCH_RESIDENCE_REMINDERS:
        draft.isFetchingResidenceReminders = true;
        draft.currentResidenceReminder = {};
        break;
      case FETCH_RESIDENCE_REMINDERS_SUCCESS:
        draft.isFetchingResidenceReminders = false;
        draft.residenceReminders = action.payload;
        break;
      case FETCH_RESIDENCE_REMINDERS_FAILURE:
        draft.isFetchingResidenceReminders = false;
        break;
      case ADD_RESIDENCE_FAMILY_MEMBER:
        draft.isSubmitting = true;
        break;
      case ADD_RESIDENCE_FAMILY_MEMBER_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_RESIDENCE_FAMILY_MEMBER_FAILURE:
        draft.isSubmitting = false;
        break;
      // EDIT RESIDENCE FAMILY MEMBER
      case EDIT_RESIDENCE_FAMILY_MEMBER:
        draft.isSubmitting = true;
        break;
      case EDIT_RESIDENCE_FAMILY_MEMBER_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_RESIDENCE_FAMILY_MEMBER_FAILURE:
        draft.isSubmitting = false;
        break;

      // List Family Members
      case FETCH_RESIDENCE_FAMILY_MEMBERS:
        draft.isFetchingResidenceFamilyMembers = true;
        draft.currentResidenceReminder = {};
        break;
      case FETCH_RESIDENCE_FAMILY_MEMBERS_SUCCESS:
        draft.isFetchingResidenceFamilyMembers = false;
        draft.residenceFamilyMembers = action.payload;
        break;
      case FETCH_RESIDENCE_FAMILY_MEMBERS_FAILURE:
        draft.isFetchingResidenceFamilyMembers = false;
        break;
      // View
      case GET_FAMILY_VIEW_DATA:
        draft.isFetching = true;
        draft.currentResidenceFamily = {};
        break;
      case GET_FAMILY_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentResidenceFamily = action.payload;
        break;
      case GET_FAMILY_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      default:
        return state;
    }
  });

export default ResidenceReducer;
